import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";

var getVerticalPaddingsWithCompensation = function getVerticalPaddingsWithCompensation(theme) {
  var toastPaddingY = theme.toastPaddingY,
      fontFamilyCompensationBaseline = theme.fontFamilyCompensationBaseline;
  var paddingY = parseInt(toastPaddingY);
  var compensation = parseInt(fontFamilyCompensationBaseline);
  return [paddingY - compensation + "px", paddingY + compensation + "px"];
};

export var styles = memoizeStyle({
  root: function root(t) {
    var _getVerticalPaddingsW = getVerticalPaddingsWithCompensation(t),
        paddingTop = _getVerticalPaddingsW[0],
        paddingBottom = _getVerticalPaddingsW[1];

    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      border-radius: ", ";\n      border: ", ";\n      color: ", ";\n      display: inline-flex;\n      font-size: ", ";\n      line-height: ", ";\n      opacity: 1;\n      padding: ", " ", " ", ";\n      position: relative;\n      top: ", ";\n    "])), t.toastBg, t.toastBorderRadius, t.toastBorder, t.toastColor, t.toastFontSize, t.toastLineHeight, paddingTop, t.toastPaddingX, paddingBottom, t.toastTop);
  },
  wrapper: function wrapper() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 0;\n      text-align: center;\n    "])));
  },
  closeWrapper: function closeWrapper(t) {
    var _getVerticalPaddingsW2 = getVerticalPaddingsWithCompensation(t),
        paddingTop = _getVerticalPaddingsW2[0],
        paddingBottom = _getVerticalPaddingsW2[1];

    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      margin: -", " -", " -", " -", ";\n    "])), paddingTop, t.toastPaddingX, paddingBottom, t.toastClosePadding);
  },
  link: function link(t) {
    var _getVerticalPaddingsW3 = getVerticalPaddingsWithCompensation(t),
        paddingTop = _getVerticalPaddingsW3[0],
        paddingBottom = _getVerticalPaddingsW3[1];

    var marginRight = Math.round(parseInt(t.toastPaddingX) * 1.5) + "px";
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      cursor: pointer;\n      display: inline-block;\n      font-weight: 600;\n\n      margin: -", " ", " -", " ", ";\n\n      padding: ", " 0 ", ";\n\n      &:hover {\n        text-decoration: underline;\n      }\n    "])), t.toastLinkColor, paddingTop, marginRight, paddingBottom, t.toastPaddingX, paddingTop, paddingBottom);
  },
  close: function close(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      box-sizing: content-box !important; // fix \"reset.css\" problem\n      color: ", ";\n      cursor: pointer;\n      display: inline-block;\n      height: ", ";\n      line-height: 0;\n      padding: ", ";\n      text-align: center;\n      width: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), t.toastCloseColor, t.toastCloseSize, t.toastClosePadding, t.toastCloseSize, t.toastCloseHoverColor);
  }
});